export default class Header {

  constructor() {
    if (this.setVars()) {
      this.setEvents();
    }
  }

  setVars() {
    
    this.settings = {
      'main': 'data-header',
      'wrapper': 'data-header-wrapper',
      'scroll_top': 'data-scroll-top',
    };

    this.header = document.querySelector(`[${this.settings.main}]`);
    
    if (!this.header) return;
    this.lastScrollTop = 0;
    this.setScrolled();

    return true;
  }

  setEvents() {
    window.addEventListener('scroll', () => {
      this.setScrolled();
    });
  }
  
  setScrolled () {
    const st = window.pageYOffset || document.documentElement.scrollTop;
    // const wrapper = this.header.querySelector(`[${this.settings.wrapper}]`);
    const scrollTop = document.querySelector(`[${this.settings.scroll_top}]`);
    
    if (st > 50) {
      this.header.addClass('scrolled');
      scrollTop.addClass('active');
    } else {
      this.header.removeClass('scrolled');
      scrollTop.removeClass('active');
    }
  }
}
